import { LoadingOutlined } from "@ant-design/icons";
import { Spin as AntdSpin, SpinProps as AntdSpinProps } from "antd";
import { themeColors } from "index";
import React, { CSSProperties } from "react";
import { spinWithoutBlur } from "./LoadingSpinWithoutBlur.css";

export type LoadingSpinWithoutBlurProps = {
  iconcolor?: CSSProperties["color"];
  noSpin?: boolean;
} & AntdSpinProps;

const LoadingSpinWithoutBlur = ({
  iconcolor,
  style,
  indicator,
  ...props
}: LoadingSpinWithoutBlurProps) => {
  return (
    <AntdSpin
      wrapperClassName={spinWithoutBlur}
      indicator={indicator ? indicator : <LoadingOutlined spin />}
      style={{ color: iconcolor ?? themeColors.default.neutral.dark, ...style }}
      {...props}
    />
  );
};

export default LoadingSpinWithoutBlur;
